module.exports = __webpack_public_path__ + "img/genre3.0613d752.svg";